import { Phone } from 'lucide-react'
import type { BlockProps } from '../types.js'
import { SectionWrapper } from './SectionWrapper.js'
import styles from './common.module.css'

export function ContactsBlock({ invitation, activeSection, onSectionClick, mode }: BlockProps) {
  const groom = invitation.groom
  const bride = invitation.bride
  const hasData = !!(
    groom?.phone || groom?.fatherPhone || groom?.motherPhone ||
    bride?.phone || bride?.fatherPhone || bride?.motherPhone
  )

  return (
    <SectionWrapper
      sectionId="contacts"
      activeSection={activeSection}
      onSectionClick={onSectionClick}
      mode={mode}
      className={styles.section}
    >
      <span className={styles.sectionTitle}>연락처</span>
      <div className={styles.divider} />
      {hasData ? (
        <div className={styles.contactList}>
          {(groom?.phone || groom?.fatherPhone || groom?.motherPhone) && (
            <div className={styles.contactGroup}>
              <span className={styles.accountLabel}>신랑 측</span>
              {groom?.phone && (
                <ContactRow label="신랑" phone={groom.phone} />
              )}
              {groom?.fatherPhone && (
                <ContactRow label="아버지" phone={groom.fatherPhone} />
              )}
              {groom?.motherPhone && (
                <ContactRow label="어머니" phone={groom.motherPhone} />
              )}
            </div>
          )}
          {(bride?.phone || bride?.fatherPhone || bride?.motherPhone) && (
            <div className={styles.contactGroup}>
              <span className={styles.accountLabel}>신부 측</span>
              {bride?.phone && (
                <ContactRow label="신부" phone={bride.phone} />
              )}
              {bride?.fatherPhone && (
                <ContactRow label="아버지" phone={bride.fatherPhone} />
              )}
              {bride?.motherPhone && (
                <ContactRow label="어머니" phone={bride.motherPhone} />
              )}
            </div>
          )}
        </div>
      ) : (
        <p className={styles.placeholderText}>연락처 정보가 여기에 표시됩니다</p>
      )}
    </SectionWrapper>
  )
}

function ContactRow({ label, phone }: { label: string; phone: string }) {
  return (
    <div className={styles.contactRow}>
      <span className={styles.contactLabel}>{label}</span>
      <span className={styles.contactPhone}>
        <Phone size={10} />
        {phone}
      </span>
    </div>
  )
}
